<template>
  <div class="modal-footer">
    <slot/>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ModalFooter',
});
</script>

<style scoped>
.modal-footer :deep(.btn:not(.rounded-circle)) {
  border-radius: 8px !important;
}
</style>
